import React from 'react'
import {SVNumber,SVNArray, SVStringEp, SVDate, SVEDDInputEp,SVIDDInputEp,SVNAOInputEp,SVVCOInputEp,SVICOInputEp ,SVBPInputEp, SVILInputEp,SVDNInputEp} from '../core'

import {   Field} from 'redux-form'

/*svj21 start */

//import {SVNumber,SVNArray, SVString,SVStringEp, SVDate, SVInput, SVInputEp, SVICInputEp,SVBPInputEp, SVILInputEp,SVVCInputEp, SVNAInputEp,SVDNInputEp, SVEDInputEp} from '../core'
/*svj21 end */

  class SVARoomComponentEp extends React.Component{
    

    constructor(props){
        super(props)
        this.svDDChange = this.svDDChange.bind(this)
        this.svfieldType=  this.props.portType || 'CL_String'
        this.state={
            svfieldType: this.props.portType || 'CL_String'
        }
       

    }
    componentWillReceiveProps(next){
        console.log(next)

    }

    svDDChange(e){
        //this.refs.DropdownList.refs
        //this.refs.DropdownList.refs.inner.handleClick()
        console.log(e)

        //ob.target.value
        if(e.target.value =='string'){
            console.log('sv change action to change class')
           // this.props.initialValues.gene
            this.svfieldType= 'CL_String'
        }else if(e.target.value == 'date'){
            this.svfieldType= 'CL_Date'
        }else if(e.target.value == 'narray'){
            this.svfieldType= 'CL_NArray'    

        }else{
            this.svfieldType= 'CL_Number'
        }

        this.setState({
            svfieldType:this.svfieldType
        })

    }
/*
"documents": [
        {
            
            "documentType": "IDENTITY_CARD",
            "adultType": "t5",
             "childType": "m2",

            "holder": "Y"
           
            
        }
    ],
*/
    renderBig(){
        let me = this
       
        //  this.props.initialValues.svfieldType= 'CL_String'
        console.log(this.props)
        const {member, index, portTypes, childTypes,adultTypes}= this.props
        console.log(member)
          /*svj21 start*/
        
          console.log("*******svj2****ADoc countryTwoTypes** START")
        

          console.log("*******svj2****ADevice** END")

            /*svj21 end*/
      

      
        return ( 
        <div className="box-block">  
       
       <div className="form-group">
                <label htmlFor={`${member}.documentType`}  > adultType</label>
                <Field  component="select" id={`${member}.adultType`}   name={`${member}.adultType`} className="form-control" >
                
                    <option value="">Select Total Adults</option>
                    {
        
                
        adultTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
       </div>
      
        <div className="form-group">
                <label htmlFor={`${member}.childType`}  > childType</label>
                <Field  component="select" id={`${member}.childType`}   name={`${member}.childType`} className="form-control" >
                
                    <option value="">Select Child Type for (Port)  </option>
                    {
        
                
        childTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
        </div>



        
               
    
        
        
       
        </div>     )


    }

    render(){
        let me = this
       
        //  this.props.initialValues.svfieldType= 'CL_String'
        console.log(this.props)
        const {member, index, portTypes, childTypes,adultTypes}= this.props
        console.log(member)
          /*svj21 start*/
        
          console.log("*******svj2****ADoc countryTwoTypes** START")
        

          console.log("*******svj2****ADevice** END")

            /*svj21 end*/
      

      
        return ( 
           
            <div className="row">
                 {/*
             <div className="form-group">
                <label htmlFor={`${member}.childType`}  > childType</label>
                <Field  component="select" id={`${member}.childType`}   name={`${member}.childType`} className="form-control" >
                
                    <option value="">Select Child Type for (Port)  </option>
                    {
        
                
        childTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                    
                    
                    
                   
                )}
        
                </Field>
        </div>



        
               
    
        
        
       
        </div>  
            */}
                <div className="c-container-profilebar">
                    
                    <div className="c-box-profilebar">
                                <span className="c-span">
                                     <Field  component="select" id={`${member}.adultType`}   name={`${member}.adultType`} className="form-control" >
                
                                            <option value="">Select Total Adults</option>
                                            {
                                
                                        
                                adultTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                                            
                                            
                                            
                                        
                                        )}
                                
                                        </Field>
                                </span>
                    </div>
                    <div className="c-box-profilebar">
                                <span className="c-span">
                                <Field  component="select" id={`${member}.childType`}   name={`${member}.childType`} className="form-control" >
                
                <option value="">Select Child Type for (Port)  </option>
                {
    
            
    childTypes.map(  (o, idx)=>(  <option value={o.value} key={o.name}>{o.name}</option>)
                
                
                
               
            )}
    
            </Field>
                                </span>
                    </div>
                </div>
            </div>
      
      
          )


    }

    
}

export default SVARoomComponentEp